import { headerNavigationItems } from '@/data/navigation';

import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import useMobileMenu from './useMobileMenu';
import HeaderBrand from './HeaderBrand';

const Header = () => {
  const {
    isMenuOpen,
    menuButtonRef,
    mobileMenuRef,
    toggleMenu,
    closeMenu,
    handleMenuButtonKeyDown,
    handleMenuKeyDown,
  } = useMobileMenu();

  return (
    <header className="relative w-full border-b border-border text-sm">
      <HeaderBrand />
      <DesktopNavigation items={headerNavigationItems} />
      <MobileNavigation
        items={headerNavigationItems}
        isOpen={isMenuOpen}
        menuButtonRef={menuButtonRef}
        mobileMenuRef={mobileMenuRef}
        onToggle={toggleMenu}
        onClose={closeMenu}
        onMenuButtonKeyDown={handleMenuButtonKeyDown}
        onMenuKeyDown={handleMenuKeyDown}
      />
    </header>
  );
};

export default Header;
